import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { legalAPI } from '@/lib/api';
import { toast } from 'sonner';
import LawWizard from './LawWizard';

export default function LawEdit() {
  const { lawId } = useParams();
  const navigate = useNavigate();
  const [law, setLaw] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await legalAPI.getLaw(lawId);
        const data = res.data;

        if (data.status !== 'draft') {
          toast.error('Only draft laws can be edited. Archive this law and create a new version.');
          navigate(`/laws/${lawId}`);
          return;
        }

        setLaw(data);
      } catch {
        toast.error('Failed to load law');
        navigate('/laws');
      }
      setLoading(false);
    };
    fetch();
  }, [lawId, navigate]);

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!law) return null;

  return <LawWizard initialData={law} editMode={true} editLawId={lawId} />;
}
